import { useQuery } from '@tanstack/react-query';
import { configCenterApi } from '../api/configCenterApi';
import type { ConfigChangesFilter } from '../types/configCenter';

/**
 * GET /api/eraf/config-center/changes — 변경 피드 (CONFIG_CENTER_READ)
 * queryKey: ['config-center', 'changes', filters]
 */
export function useConfigChanges(filters: ConfigChangesFilter, enabled = true) {
  return useQuery({
    queryKey: ['config-center', 'changes', filters],
    queryFn: () =>
      configCenterApi.changes({
        configKey: filters.configKey || undefined,
        changeType: filters.changeType || undefined,
        from: filters.from || undefined,
        to: filters.to || undefined,
        page: filters.page ?? 0,
        size: filters.size ?? 20,
        sort: filters.sort ?? 'changedAt,desc',
      }),
    enabled,
    staleTime: 15_000,
    refetchInterval: enabled ? 30_000 : false,
  });
}
